import Axios from '../axios';
import Mappings from '../api.mappings';
export class OrganizationApi {
    // 错误处理
    errorHandle(res) {
        if (res.hasOwnProperty('errcode') && res.errcode !== 0) {
            return Promise.reject(res);
        }
        return res;
    }
    // 下一级-组织树
    getOrgTree(deptIds, filterType, sourceType, corpId, excludeCorpId, selectUserIds, workflowInstanceId, activityCode, formRootDeptIds, queryType) {
        return Axios.get(Mappings.organization.departmentTree, {
            params: {
                deptIds,
                filterType,
                sourceType,
                corpId,
                excludeCorpId,
                selectUserIds,
                workflowInstanceId,
                activityCode,
                formRootDeptIds,
                queryType,
            }
        }).then(this.errorHandle);
    }
    // 下一级-用户
    getUsersTree(deptId, roleId, filterType, sourceType, workflowInstanceId, activityCode, formRootDeptIds, queryType) {
        return Axios.get(Mappings.organization.departmentListUser, {
            params: {
                deptId,
                roleId,
                filterType,
                sourceType,
                workflowInstanceId,
                activityCode,
                formRootDeptIds,
                queryType,
            }
        }).then(this.errorHandle);
    }
    /**
     * 选人控件根据名称搜索人或部门
     * @param name
     * @param deptIds 部门编码 “,”分割
     * @param roleIds 角色编码 “,”分割
     */
    search(name, queryType, deptIds, roleIds, filterType, sourceType, corpId, excludeCorpId, workflowInstanceId, activityCode, formRootDeptIds) {
        return Axios.get(Mappings.organization.userTreeSearch, {
            params: {
                name,
                deptIds,
                roleIds,
                filterType,
                sourceType,
                corpId,
                excludeCorpId,
                workflowInstanceId,
                activityCode,
                formRootDeptIds,
                queryType,
            }
        }).then(this.errorHandle);
    }
    getRoleGroupList(expandAll) {
        return Axios.get(Mappings.organization.roleTree, {
            params: {
                expandAll: !!expandAll
            }
        });
    }
    getRoleGroupList2(params) {
        params = params || {};
        return Axios.get(Mappings.organization.roleTree, {
            params
        });
    }
    getRolesByGroupid(groupId) {
        return Axios.get(Mappings.organization.roleUsersByGroupid, {
            params: {
                groupId,
            }
        });
    }
    searchRolesByName(params) {
        return Axios.get(Mappings.organization.searchRoleByName, {
            params
        });
    }
    getRoleGroupByCode(roleCode) {
        return Axios.get(Mappings.organization.roleGroupByCode, {
            params: {
                roleCode
            }
        });
    }
    getRoleGroupById(roleId) {
        return Axios.get(Mappings.organization.roleGroupById, {
            params: {
                roleId
            }
        });
    }
    getRolesByGroupParams(params) {
        return Axios.get(Mappings.organization.getRolesByGroupParams, {
            params
        });
    }
    getRoleLeveOneInfoNew(expandAll, reqSource) {
        // 组织角色
        return Axios.get("/api/organization/role/listNesting", {
            params: {
                expandAll: !!expandAll,
                reqSource: reqSource ? 'modify_user_role' : undefined,
                filterEmptyRelatedSetting: true,
                filterDefaultRoleGroup: true,
            },
        });
    }
    searchRoleListNew(searchKey, reqSource) {
        // 模糊搜索角色列表
        return Axios.get("/api/organization/role/searchNesting", {
            params: {
                name: searchKey,
                reqSource: reqSource ? 'modify_user_role' : undefined,
                filterDefaultRoleGroup: true,
            },
        });
    }
    getChildrenRoleNew(params) {
        return Axios.get("/api/organization/role/childsNesting", { params }); // 获取子组织角色
    }
}
;
